import { useCallback, useState } from 'react'
import {
  ActivityHistorySearchInput,
  toggleFilterActionCreator,
} from '@user/features/Activity/state'
import { useActivitiesContext } from '@user/features/Activity/context'

export function useHandlers() {
  const [, dispatch] = useActivitiesContext()
  const [search, setSearch] = useState<ActivityHistorySearchInput>()

  const onCheckboxChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) =>
      dispatch(toggleFilterActionCreator(event.target.value)),
    [dispatch],
  )

  return { onCheckboxChange, search, setSearch }
}
